var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.html)?_c('div',{staticClass:"embed",domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }